import React from 'react';
import {withRouter} from 'react-router-dom';

import ImportExportRecords from '../../components/shared/ImportExportRecords/ImportExportRecords';

const ExportRecords = ({
    user
}) => {

    return (
        <ImportExportRecords 
            user={user}
            s_type={'EXPORT'}
        />
    );
}

export default withRouter(ExportRecords);